import { Notification } from "../../local_modules/voy-fleet-sub-view/src/types";
import { authFetchGET, authFetchPOST, authFetchPUT, authFetchFile } from "../utils/auth-fetch";
import { NotificationType } from "./types/fleet-notification-service.types";
import { WeatherRoutingNotification } from "./types/fleet-weather-routing-notification.types";

const env = (<any>window)["appenv"].services.notifications;
const weatherRoutingAuditEnv = (<any>window)["appenv"].services.weatherRoutingAudit;
const weatherRoutingEnv =  (<any>window)["appenv"].services.weatherRouting;

export class FleetNotificationService {
    static async getNotifications(type:string): Promise<NotificationType[]> {
        const query = `${env.baseurl}/v1/VesselNotifications/by-deviation-type?state=Active&category=Voyage&type=${type}`;
        return await authFetchGET(env.scope, query) 
    }

    static async getNotificationsLog(imo:number,type:string): Promise<NotificationType[]> {
        const query = `${env.baseurl}/v1/VesselNotifications/by-deviation-type?category=Voyage&type=${type}&&imo_no=${imo}`;
        return await authFetchGET(env.scope, query) 
    }

    static async postFeedback(payload: any): Promise<NotificationType[]> {
        const query = `${env.baseurl}/v1/VesselNotifications`;
        return await authFetchPOST(env.scope, query,payload) 
    }

    static convertDate(inputDate: string): string {
        let date = new Date(inputDate);
        let year = date.getUTCFullYear();
        let month = String(date.getUTCMonth() + 1).padStart(2, '0');
        let day = String(date.getUTCDate()).padStart(2, '0');
        let hours = String(date.getUTCHours()).padStart(2, '0');
        let minutes = String(date.getUTCMinutes()).padStart(2, '0');
        let seconds = String(date.getUTCSeconds()).padStart(2, '0');
    
        let formattedTime = `${hours}%3A${minutes}%3A${seconds}`;
    
        return `${year}-${month}-${day}T${formattedTime}.000Z`;
    }
    
    static async getFeedbackSubmittedHistory(): Promise<NotificationType[]> {
        const currentDate = new Date();
        const startOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const formattedStartDate = FleetNotificationService.convertDate(startOfCurrentMonth.toISOString());
        const formattedEndDate = FleetNotificationService.convertDate(currentDate.toISOString());
        const query = `${env.baseurl}/v1/VesselNotifications?category=Voyage&type=FleetNPS&imo_no=1000000&started_at=${formattedStartDate}&ended_at=${formattedEndDate}`;
        return await authFetchGET(env.scope, query);
    }
    static async getBprInformation(imo:number,type:string): Promise<Notification[]> {
        const query = `${env.baseurl}/v1/VesselNotifications?category=Voyage&type=${type}&imo_no=${imo}`;
        return await authFetchGET(env.scope, query) 
    }
    static async getAllNotifications(type: string): Promise<NotificationType[]>{
        const currentDate = new Date();
        const oneMonthAgoDate = new Date(currentDate);
        oneMonthAgoDate.setMonth(currentDate.getMonth() - 1);
        const formattedStartDate = FleetNotificationService.convertDate(oneMonthAgoDate.toISOString());
        const formattedEndDate = FleetNotificationService.convertDate(currentDate.toISOString());
        const query = `${env.baseurl}/v1/VesselNotifications?category=Voyage&type=${type}&started_at=${formattedStartDate}&ended_at=${formattedEndDate}`;
        return await authFetchGET(env.scope, query);
    }

    static async updateNotification(notificationId: string, payload: any): Promise<NotificationType[]> {
        const query = `${env.baseurl}/v1/VesselNotifications/${notificationId}/Responses`;
        return await authFetchPOST(env.scope, query, payload)
    }

    static async getWeatherRoutingNotifications(imo:number = 0): Promise<WeatherRoutingNotification[]> {
        let query = `${weatherRoutingAuditEnv.baseurl}/activitylog`;
        if(imo){
            query += `?imo=${imo}`;
        }
        return await authFetchGET(weatherRoutingAuditEnv.scope, query) 
    }

    static async updateWeatherRoutingNotifications(payload:any): Promise<WeatherRoutingNotification[]> {
        let query = `${weatherRoutingAuditEnv.baseurl}/activitylog`;
        return await authFetchPUT(weatherRoutingAuditEnv.scope, query,payload) 
    }

    static async openWRAdvicePDF(correlationId: string): Promise<void>{
        let query = `${weatherRoutingEnv.baseurl}/pdf/download/correlationId/${correlationId}`;
        let response =  await authFetchFile(weatherRoutingEnv.scope, query)
        const blob = await response.blob(); 
        const blobUrl = URL.createObjectURL(blob); 
        window.open(blobUrl, "_blank");
    }
    static async fetchSID(auditId:number): Promise<any>{
        try {
            let query = `${weatherRoutingAuditEnv.baseurl}/audit/getSid/auditlogid/${auditId}`;
            let response =  await authFetchGET(weatherRoutingAuditEnv.scope, query) 
            return response
        }
        catch (err) {
            console.error(err);
            return "";
        }
       
    }

static async getOfflineVesselNotifications(): Promise<NotificationType[]> {
    const activeQuery = `${env.baseurl}/v1/VesselNotifications?state=Active&category=Voyage&type=vesseloffline`;
    const inProgressQuery = `${env.baseurl}/v1/VesselNotifications?state=in-progress&category=Voyage&type=vesseloffline`;
    
    const [activeResults, inProgressResults] = await Promise.all([
        authFetchGET(env.scope, activeQuery),
        authFetchGET(env.scope, inProgressQuery)
    ]);
    
    return [...activeResults, ...inProgressResults];
}
}
